<template>
    <div class="middleContent">
        <div class="middleHeader" v-if="parentId">
            <span class="title-text">{{ headerContent.text }}</span>
            <div class="header-actions">
                <el-button type="primary" size="mini" @click="addFunction">{{ $t('resource.addFunction') }}</el-button>
                <el-button type="danger" size="mini" :disabled="tableRow.length === 0" @click="batchDelete">{{ $t('public.btn_delete') }}</el-button>
            </div>
        </div>
        <!-- 否则显示文本目录菜单 -->
        <v-header v-else :Content="{ text: $t('integration.contents_menu') }" />

        <el-table
            stripe
            ref="multipleTable"
            v-loading="loading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            class="table"
            :height="tableHeight"
            :header-cell-style="headCellStyle"
            :cell-style="bodyCellStyle"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" show-overflow-tooltip :label="$t('resource.func')"></el-table-column>
            <el-table-column prop="nameZh" show-overflow-tooltip :label="$t('resource.nameZh')"></el-table-column>
            <el-table-column prop="nameEn" show-overflow-tooltip :label="$t('resource.nameEn')"></el-table-column>
            <el-table-column prop="code" show-overflow-tooltip :label="$t('resource.funcCode')"></el-table-column>
            <el-table-column prop="extraCode" show-overflow-tooltip :label="$t('resource.extraCode')"></el-table-column>
            <el-table-column prop="operate" :label="$t('resource.optare')" width="120">
                <template #default="{ row }">
                    <div class="uk-flex uk-flex-center">
                        <i
                            :title="$t('resource.edit')"
                            class="el-icon-edit icon"
                            @click="editFunction(row)"
                        ></i>
                        <i
                            :title="$t('resource.delete')"
                            class="el-icon-delete icon"
                            @click="delFunction(row)"
                        ></i>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!-- V8: 功能弹出框 -->
        <v-function-dialog ref="functionDialog" @saved="onFunctionSaved" />
    </div>
</template>

<script>
import HeaderVue from './Header.vue';
import FunctionDialogVue from './FunctionDialog.vue';
import eventBus from '../bus';
import { functionOperatePage, functionOperateDel, functionDetail } from '@/api/modules/resoure.js';

export default {
    components: {
        'v-header': HeaderVue,
        'v-function-dialog': FunctionDialogVue
    },
    data() {
        return {
            headerContent: {
                text: null,
                iconArray: []
            },
            tableData: [],
            tableHeight: 'calc(100% - 60px)',
            total: 0,
            quertList: {
                iDisplayStart: 0,
                iDisplayLength: 1000,
                pageId: null,
                subId: null
            },
            loading: false,
            treeRow: {},
            tableRow: [],
            parentId: null
        };
    },
    mounted() {
        this.getMenuTextFn();
    },
    methods: {
        getListFn(str) {
            this.loading = true;
            functionOperatePage(this.quertList)
                .then(({ result }) => {
                    this.tableData = result || [];
                    if (str) {
                        eventBus.$emit('canselChooze', { str, result });
                    } else {
                        eventBus.$emit('canselChooze', { result });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getMenuTextFn() {
            eventBus.$on('getMenuText', obj => {
                const { parentId } = obj;
                this.parentId = parentId;

                this.tableData = [];
                const isZh = (this.$i18n.locale || '').indexOf('zh') === 0;
                const row = obj.row || {};
                const translatedName = isZh ? (row.nameZh || row.name) : (row.nameEn || row.name);
                this.headerContent.text = obj.text || translatedName;
                this.treeRow = obj.row;

                if (!obj.row.parentCode) {
                    this.quertList.pageId = obj.row.id;
                    this.quertList.subId = null;
                    this.tableData = [];
                } else {
                    this.quertList.pageId = null;
                    this.quertList.subId = obj.row.id;
                    this.getListFn();
                }
            });
        },
        handleSelectionChange(arg) {
            this.tableRow = arg;
        },
        /** 新增功能 - 打开弹出框 */
        addFunction() {
            this.$refs.functionDialog.open(null, this.treeRow);
        },
        /** 编辑功能 - 打开弹出框 */
        editFunction(row) {
            this.$refs.functionDialog.open(row, this.treeRow);
        },
        /** 弹出框保存成功回调 */
        onFunctionSaved() {
            this.getListFn();
        },
        /** 批量操作下拉命令 */
        handleBatchCommand(command) {
            if (command === 'delete') {
                this.batchDelete();
            }
        },
        /** 根据当前选中菜单获取查询参数（二级菜单用 subId，一级菜单用 pageId） */
        getDetailParams() {
            if (this.treeRow.parentCode) {
                return { pageId: null, subId: this.treeRow.id ? String(this.treeRow.id) : null };
            }
            return { pageId: this.treeRow.id ? String(this.treeRow.id) : null, subId: null };
        },
        /** 删除功能（按 code 删除所有相关 URL） */
        delFunction(row) {
            this.$confirm(this.$t('messageTitle.DeleteToContinue'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'),
                cancelButtonText: this.$t('public.btn_cancel'),
                type: 'warning'
            })
                .then(() => {
                    const params = this.getDetailParams();
                    functionDetail({ code: row.code, ...params }).then(({ result }) => {
                        if (!result || !result.urls || result.urls.length === 0) {
                            this.$message.warning(this.$t('resource.noData'));
                            return;
                        }
                        const ids = result.urls.map(item => item.id).join(',');
                        functionOperateDel({ ids }).then(({ state }) => {
                            if (state.code === 200) {
                                this.getListFn('del');
                                this.$message.success(this.$t('public.tip_del_succ').toString());
                            }
                        });
                    });
                })
                .catch(() => {});
        },
        /** 批量删除 */
        batchDelete() {
            if (this.tableRow.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            this.$confirm(this.$t('messageTitle.DeleteToContinue'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'),
                cancelButtonText: this.$t('public.btn_cancel'),
                type: 'warning'
            })
                .then(() => {
                    const params = this.getDetailParams();
                    const promises = this.tableRow.map(row => {
                        return functionDetail({ code: row.code, ...params }).then(({ result }) => {
                            if (result && result.urls && result.urls.length > 0) {
                                const ids = result.urls.map(item => item.id).join(',');
                                return functionOperateDel({ ids });
                            }
                        });
                    });
                    Promise.all(promises).then(() => {
                        this.getListFn('del');
                        this.$message.success(this.$t('public.tip_del_succ').toString());
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style lang="scss" scoped>
.middleContent {
    height: 100%;
    box-sizing: border-box;
    position: relative;

    .middleHeader {
        height: 50px;
        width: 100%;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #c7c7c7;
        box-sizing: border-box;

        .title-text {
            font-size: 16px;
            font-weight: bold;
            color: #344962;
        }

        .header-actions {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .table {
        padding: 10px;
    }

    .icon {
        font-size: 14px;
        line-height: 38px;
        cursor: pointer;
        margin: 0 5px;
    }
}
</style>
